import React, { Fragment } from "react";
import SearchSuperAdmin from "./SearchSuperAdmin";
import { useSelector } from "react-redux";

export default function Index() {
  const auth = useSelector((state) => state.auth);

  return <Fragment>{auth.profile === 1 && <SearchSuperAdmin />}</Fragment>;
}
